import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <section class="user-navigation user-navigation-primary">
  <HorizontalOverflowNav
    @ariaLabel="User primary"
    class="main-nav nav user-nav"
  >
    {{#unless @user.profile_hidden}}
      <DNavigationItem @route="user.summary" class="user-nav__summary">
        {{d-icon "user"}}
        <span>{{i18n "user.summary.title"}}</span>
      </DNavigationItem>

      {{#if @showActivityTab}}
        <DNavigationItem
          @route="userActivity"
          @ariaCurrentContext="parentNav"
          class="user-nav__activity"
        >
          {{d-icon "stream"}}
          <span>{{i18n "user.activity_stream"}}</span>
        </DNavigationItem>
      {{/if}}
    {{/unless}}

    {{#if @showNotificationsTab}}
      <DNavigationItem
        @route="userNotifications"
        @ariaCurrentContext="parentNav"
        class="user-nav__notifications"
      >
        {{d-icon "bell" class="glyph"}}
        <span>{{i18n "user.notifications"}}</span>
      </DNavigationItem>
    {{/if}}

    {{#if @showPrivateMessages}}
      <DNavigationItem
        @route="userPrivateMessages"
        @ariaCurrentContext="parentNav"
        class="user-nav__personal-messages"
      >
        {{d-icon "envelope"}}
        <span>{{i18n "user.private_messages"}}</span>
      </DNavigationItem>
    {{/if}}

    {{#if @canInviteToForum}}
      <DNavigationItem
        @route="userInvited"
        @ariaCurrentContext="parentNav"
        class="user-nav__invites"
      >
        {{d-icon "user-plus"}}
        <span>{{i18n "user.invited.title"}}</span>
      </DNavigationItem>
    {{/if}}

    {{#if @showBadges}}
      <DNavigationItem @route="user.badges" class="user-nav__badges">
        {{d-icon "certificate"}}
        <span>{{i18n "badges.title"}}</span>
      </DNavigationItem>
    {{/if}}

    <PluginOutlet
      @name="user-main-nav"
      @connectorTagName="li"
      @outletArgs={{hash model=@user}}
    />

    {{#if @user.can_edit}}
      <DNavigationItem
        @route="preferences"
        @ariaCurrentContext="parentNav"
        class="user-nav__preferences"
      >
        {{d-icon "cog"}}
        <span>{{i18n "user.preferences.title"}}</span>
      </DNavigationItem>
    {{/if}}
    {{#if (and @isMobileView @isStaff)}}
      <li class="user-nav__admin">
        <a href={{@user.adminPath}}>
          {{d-icon "wrench"}}
          <span>{{i18n "admin.user.manage_user"}}</span>
        </a>
      </li>
    {{/if}}
  </HorizontalOverflowNav>
</section>
*/
{
  "id": "64K00Zb8",
  "block": "[[[10,\"section\"],[14,0,\"user-navigation user-navigation-primary\"],[12],[1,\"\\n  \"],[8,[39,0],[[24,0,\"main-nav nav user-nav\"]],[[\"@ariaLabel\"],[\"User primary\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[51,[30,1,[\"profile_hidden\"]]],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__summary\"]],[[\"@route\"],[\"user.summary\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"user\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"user.summary.title\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,2],[[[1,\"        \"],[8,[39,2],[[24,0,\"user-nav__activity\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userActivity\",\"parentNav\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,3],[\"stream\"],null]],[1,\"\\n          \"],[10,1],[12],[1,[28,[35,4],[\"user.activity_stream\"],null]],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__notifications\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userNotifications\",\"parentNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"bell\"],[[\"class\"],[\"glyph\"]]]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"user.notifications\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,4],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__personal-messages\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages\",\"parentNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"envelope\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"user.private_messages\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,5],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__invites\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userInvited\",\"parentNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"user-plus\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"user.invited.title\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,6],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__badges\"]],[[\"@route\"],[\"user.badges\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"certificate\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"badges.title\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,6],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-main-nav\",\"li\",[28,[37,7],null,[[\"model\"],[[30,1]]]]]],null],[1,\"\\n\\n\"],[41,[30,1,[\"can_edit\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"user-nav__preferences\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"preferences\",\"parentNav\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"cog\"],null]],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,4],[\"user.preferences.title\"],null]],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[41,[28,[37,8],[[30,7],[30,8]],null],[[[1,\"      \"],[10,\"li\"],[14,0,\"user-nav__admin\"],[12],[1,\"\\n        \"],[10,3],[15,6,[30,1,[\"adminPath\"]]],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"wrench\"],null]],[1,\"\\n          \"],[10,1],[12],[1,[28,[35,4],[\"admin.user.manage_user\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]],[1,\"\\n\"],[13]],[\"@user\",\"@showActivityTab\",\"@showNotificationsTab\",\"@showPrivateMessages\",\"@canInviteToForum\",\"@showBadges\",\"@isMobileView\",\"@isStaff\"],false,[\"horizontal-overflow-nav\",\"unless\",\"d-navigation-item\",\"d-icon\",\"i18n\",\"if\",\"plugin-outlet\",\"hash\",\"and\"]]",
  "moduleName": "discourse/components/user-nav.hbs",
  "isStrictMode": false
});